import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { type PmpDealType, pmpDealType } from '@openx/types/deal';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsLabels } from '../../../../DealForm/utils/dealFormUtils';
import { useDealContext } from '../../../../utils/context/DealContext';

type OXSBuyerRenderProps = {
  pmpDealTypeValue: PmpDealType;
  buyerAccountId: string | null | undefined;
};

export const OXSBuyerRender = ({ pmpDealTypeValue, buyerAccountId }: OXSBuyerRenderProps) => {
  const { t } = useTranslation();
  const labels = getDealsLabels(t);
  const { useBuyerOrganizationsFetch } = useDealContext();

  const isPrivateAuction = pmpDealTypeValue === pmpDealType.PrivateAuction;

  const { data: oxsBuyers, isLoading } = useBuyerOrganizationsFetch(isPrivateAuction);

  const oxsBuyer = useMemo(
    () => oxsBuyers?.find(buyer => buyer.id === Number(buyerAccountId))?.name || '',
    [oxsBuyers, buyerAccountId]
  );

  return <FieldDetails loading={isLoading} title={labels.buyer_account_id} value={oxsBuyer} />;
};
